import { render, staticRenderFns } from "./person.vue?vue&type=template&id=6bed0b3a&scoped=true&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"
import style0 from "./person.vue?vue&type=style&index=0&id=6bed0b3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed0b3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bed0b3a')) {
      api.createRecord('6bed0b3a', component.options)
    } else {
      api.reload('6bed0b3a', component.options)
    }
    module.hot.accept("./person.vue?vue&type=template&id=6bed0b3a&scoped=true&", function () {
      api.rerender('6bed0b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/pay_center/write_off/components/write_off_details/person.vue"
export default component.exports